module.exports = __webpack_public_path__ + "img/I.1aa43e7d.png";